function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7293af;fill-rule:evenodd;}.cls-2{opacity:0.65;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M330.37,380.5H265.3a9.3,9.3,0,0,0-9.3,9.3V444a9.3,9.3,0,0,0,9.3,9.3h65.07a9.3,9.3,0,0,0,9.3-9.3V389.8A9.3,9.3,0,0,0,330.37,380.5Zm-1.59,68.19H266.89a6.21,6.21,0,0,1-6.24-6.17v-51.2a6.21,6.21,0,0,1,6.24-6.17h61.89a6.21,6.21,0,0,1,6.24,6.19v51.18A6.21,6.21,0,0,1,328.78,448.69Zm-5.38,7.73H273.82a2.32,2.32,0,0,0,0,4.65H323.4a2.32,2.32,0,1,0,0-4.65Z",
  transform: "translate(-256 -380.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M285.44,416.46h12.4V405.71l-12.4,1.46Zm0,10.85,12.4,1.46V418h-12.4Zm13.94-21.78v10.94h12.4v-12.4Zm0,23.42,12.4,1.46V418h-12.4Z",
  transform: "translate(-256 -380.5)"
}));

var SvgComputer = function SvgComputer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 83.67 80.57",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComputer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/computer.9fce67cb.svg";
export { ForwardRef as ReactComponent };